export class DirectMessageLoginId {
  static readonly type = '[DirectMessageLoginId] DirectMessageLoginId';

  constructor(public payload: any) {
  }
}